// extracted by LIB_CSS_EXTRACT_LOADER
import "./highlight-text_module.css"
export default {"highlight":"highlight-roGyzF"};